import { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import styled, { useTheme } from 'styled-components';

import CheckMark from '../../assets/svg/disc/check-disc.svg';
import { min } from '../../utils/breakpoints';

const StyledImg = styled.img`
  width: 50px;

  ${min.sm} {
    width: 80px;
  }
`;

/**
 * We don't actually show this screen so it is just a page to land back on after the user subscribes -
 * instead we bounce the user right onto the finalising screen and save all the account data.
 * In future we may need to handle multiple onward routes so this screen could be useful then.
 */
const SubscribedContainer = () => {
  const theme = useTheme();
  const history = useHistory();

  // Immediately redirect to the next screen where we save the account details.
  useEffect(() => history.push('/onboarding/finalising'), []);

  return (
    <>
      <h1 className="mb-3">Subscribed</h1>
      <div className="mt-1 mb-4">
        <StyledImg src={CheckMark} alt="Success checkmark" />
      </div>
      <p className="mb-0">You have subscribed to {theme.language.appName} and you can now proceed to your account.</p>
      <Button className="mb-2" onClick={() => history.push('/onboarding/finalising')}>
        Continue
      </Button>
    </>
  );
};

export default SubscribedContainer;
